export default function IosBodyOutline() {
  return (
    <div
      className="ion-icon-ios-body-outline"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<g>
	<path d="M256,47.959c17.645,0,32,14.351,32,31.991c0,17.64-14.355,31.99-32,31.99s-32-14.351-32-31.99
		C224,62.31,238.355,47.959,256,47.959 M256,31.964c-26.51,0-48,21.483-48,47.986c0,26.502,21.49,47.985,48,47.985
		s48-21.483,48-47.985C304,53.447,282.51,31.964,256,31.964L256,31.964z"/>
	<path d="M424,144H88c-13.255,0-24,10.747-24,24s10.745,24,24,24h100.451c5.549,0,13.197,4.295,17.216,14.708
		c4.651,12.055,2.37,33.33-0.539,51.444l-3.923,21.26c-0.019,0.104-0.205,0.1-0.205,0.203l-32.229,172.238
		c-2.303,13.051,6.487,25.494,19.54,27.797c1.408,0.248,2.844,0.367,4.218,0.367c11.357,0,20.917-8.19,22.97-19.836L236,340.242
		v0.166c0,0,7.25-31.408,19.452-31.408h1.096C269,309,274,340.408,274,340.408v-0.082l21.483,119.895
		c2.052,11.642,12.331,19.815,23.763,19.815c1.387,0,2.855-0.121,4.268-0.368c13.053-2.303,21.821-14.76,19.519-27.811
		l-32.349-172.251c-0.002-0.008,0.011-0.02,0.009-0.027c-0.019-0.104-0.032-0.217-0.052-0.322l-3.771-21.411
		c-2.909-18.119-5.188-39.083-0.538-51.137C310.351,196.295,318.5,192,323.549,192H424c13.255,0,24-10.747,24-24
		S437.255,144,424,144z M88,176.113c-4.411,0-8-3.646-8-8.057c0-4.411,3.589-8.057,8-8.057h336c4.411,0,8,3.59,8,8s-3.589,8-8,8
		H322.5c-15.538,0-27.438,14.738-30.982,23.922c-4.846,12.557-5.004,31.942-0.388,60.688l-0.009,0.104l0.006,0.11l3.367,19.138
		l0.562,3.241l32.252,171.628c0.5,2.834-0.62,4.961-1.332,5.977c-0.713,1.017-2.335,2.799-5.179,3.301
		c-0.476,0.083-0.955,0.126-1.427,0.126c-3.893,0-7.207-2.639-7.883-6.472L290.255,338h-0.015c-0.271-2-1.828-10.05-5.022-18.771
		c-2.278-6.217-4.844-11.034-7.844-15.005C270.283,294.836,262.135,293,256.548,293h-1.096c-5.47,0-13.503,1.731-20.71,10.938
		c-3.05,3.896-5.729,8.671-8.19,14.802c-3.628,9.037-5.505,17.654-5.708,18.613l-0.11,0.369l-20.728,119.9
		c-0.693,3.886-3.75,6.596-7.441,6.596c-0.459,0-0.932-0.043-1.403-0.127c-2.84-0.5-4.455-2.275-5.165-3.288
		c-0.709-1.013-1.824-3.136-1.323-5.975l32.257-171.562l0.004-0.019l0.174-0.927l3.775-21.33l0.022-0.125l0.021-0.126
		c4.629-28.829,4.527-48.3-0.332-60.891c-3.543-9.181-13.576-23.737-31.76-23.737"/>
</g>
</svg>
`,
      }}
    />
  )
}
